import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";

import playCircleImage from "../../../assets/play_circle.svg";
import { ReactComponent as TopSmoothy } from "../../../assets/top-smoothy.svg";
import PremiumVideoModal from "../../../components/modals/common/PremiumVideoModal";

const Home = () => {
  const { t } = useTranslation();
  const premiumVideoModalRef = useRef();

  const handleOpenModal = () => {
    premiumVideoModalRef.current?.openModal();
  };

  return (
    <div className="flex justify-center bg-blue-500">
      <div className="relative flex w-full flex-col-reverse items-center justify-between gap-10 py-10 md:py-28 lg:flex-row">
        {/* Left Side - Text Content */}
        <div className="z-10 max-w-xl text-white">
          <h1 className="mb-6 text-4xl font-extrabold leading-tight sm:text-7xl rtl:leading-snug">
            {t("the_coding_community_for_kids")}
          </h1>
          <p className="mb-6 text-lg">{t("unique_learning_experience")}</p>

          <ul className="mb-8 space-y-3">
            {[
              t("expanding_thinking_skills"),
              t("developing_communication_skills"),
              t("improving_academic_skills"),
            ].map((item, idx) => (
              <li key={idx} className="flex items-center gap-2">
                <FaCheckCircle className="text-lg text-blue-200" />
                <span className="text-base">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Side - Responsive SVG */}
        <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-4xl">
          <TopSmoothy className="h-auto w-full" />
          <img
            src={playCircleImage}
            alt="Play Video"
            className="absolute left-[50.8%] top-[55.3%] w-20 -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-transform duration-200 hover:scale-110"
            onClick={handleOpenModal}
          />
        </div>
      </div>

      {/* Premium Video Modal */}
      <PremiumVideoModal ref={premiumVideoModalRef} />
    </div>
  );
};

export default Home;
